<template>
  <div class="container">
    <div class="wrap">
      <cell-basic label="姓名">
        <div class="input-item-right">
          <input
            type="text"
            placeholder="（必填）输入身份证上的姓名"
            v-model.trim="name"
            @input="liveCheck"
          />
          <img
            class="btn_clear"
            :class="{ display: displayClearName }"
            @click="clearName"
            src="~@/assets/images/order/icon_close_travel_person@3x.png"
          />
        </div>
      </cell-basic>
      <cell-basic label="身份证">
        <div class="input-item-right">
          <input
            type="text"
            placeholder="（必填）输入身份证号"
            v-model.trim="card"
            @input="liveCheck"
            @focus="onFocusClearCard"
          />
          <img
            class="btn_clear"
            :class="{ display: displayClearCard }"
            @click="clearCard"
            src="~@/assets/images/order/icon_close_travel_person@3x.png"
          />
        </div>
      </cell-basic>
      <cell-basic label="手机号">
        <div class="input-item-right">
          <input
            type="tel"
            maxlength="11"
            placeholder="（必填）输入联系人手机号"
            v-model.trim="mobile"
            @input="liveCheck"
            @focus="onFocusClearMobile"
          />
          <img
            class="btn_clear"
            :class="{ display: displayClearMobile }"
            @click="clearMobile"
            src="~@/assets/images/order/icon_close_travel_person@3x.png"
          />
        </div>
      </cell-basic>
      <p class="tips">
        {{
          isInsurance
            ? '温馨提示：请填写领取人（或监护人）真实准确的信息。孩子王将通过加密等方式保护您录入的身份证件信息，且仅在具体交易中授权提供给相关服务提供方。'
            : '温馨提示：为避免影响出行，请您填写出行人真实准确的信息，用于入园身份验证。孩子王将通过加密等方式保护您录入的身份证件信息，且仅在具体交易中授权提供给相关服务提供方。'
        }}
      </p>
      <button v-if="tpid" class="btn_delete" @click="doDeleteConfirm">
        {{ isInsurance ? '删除' : '删除游客' }}
      </button>
      <div class="footer">
        <!--:class="{'activated':isCommitEnabled}"-->
        <a href="#" class="btn activated" @click.prevent="savePerson"
          ><i class=""></i><span>保存</span></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import findIndex from 'lodash/findIndex'
import top from '../top'
import cellBasic from './basic'
import http from '@/plugins/http'
import { Msgbox } from 'kf-component-vue'
import { Toast } from 'vant'

export default {
  components: {
    top,
    cellBasic
  },
  data() {
    return {
      tpid: '',
      name: '',
      title: '',
      mobile: '',
      card: '',
      preMobile: '',
      preCard: '',
      index: -1,
      displayClearName: false,
      displayClearMobile: false,
      displayClearCard: false,
      isCommitEnabled: false,
      isInsurance: this.$route.query.viewName === 'addUserForInsurance'
    }
  },
  props: {
    person: {
      type: Object,
      default: {}
    }
  },
  computed: {},
  watch: {
    person: function (newValue, oldValue) {
      let person = { ...newValue }
      this.tpid = person.tpid
      this.name = person.name
      this.mobile = person.mobile
      this.card = person.card
      this.index = person.index
      this.isChecked = person.isChecked
      this.title = this.tpid ? '编辑游客' : '新增游客'
    },
    name: function (newValue, oldValue) {
      this.displayClearName = !!newValue
    },
    card: function (newValue, oldValue) {
      this.displayClearCard = !!newValue
    },
    mobile: function (newValue, oldValue) {
      this.displayClearMobile = !!newValue
    }
  },
  created() {},
  mounted() {
    this.$$loading(false)
    // let person = deepClone(this.person)
    let person = { ...this.person }
    this.tpid = person.tpid
    this.name = person.name
    this.mobile = person.mobile
    this.card = person.card
    this.index = person.index
    this.isChecked = person.isChecked
    this.title = this.tpid ? '编辑游客' : '新增游客'
    if (person.tpid) {
      this.preMobile = person.mobile
      this.preCard = person.card
    }
  },
  methods: {
    clearName() {
      this.name = ''
    },
    clearCard() {
      this.card = ''
    },
    clearMobile() {
      this.mobile = ''
    },
    onFocusClearCard() {
      if (this.card && this.card.indexOf('*') !== -1) {
        this.card = ''
      }
    },
    onFocusClearMobile() {
      if (this.mobile && this.mobile.indexOf('*') !== -1) {
        this.mobile = ''
      }
    },
    liveCheck() {
      this.isCommitEnabled = !this.formCheck()
    },
    formCheck() {
      if (!this.name) {
        return '请填写姓名'
      }

      if (!this.mobile) {
        return '请填写手机号'
      }

      if (!this.card) {
        return '请填写身份证号'
      }
      const reg = /^1\d{10}$/
      if (
        this.mobile &&
        this.preMobile !== this.mobile &&
        !reg.test(this.mobile)
      ) {
        return '手机号格式不正确'
      }
      const isIdCard = this.$$isIdCard(this.card || '')
      if (this.card && this.preCard !== this.card && !isIdCard) {
        return '身份证未填写或格式不正确'
      }
      return 0
    },
    async savePerson() {
      const cck = this.formCheck()
      if (cck) {
        this.$$toast(cck)
        return
      }

      const { uid, skey } = await this.$$ensureLogin()
      if (!uid || !skey) return 1

      const qs = this.$$queryString.stringify({
        uid,
        skey,
        name: this.name,
        mobile: this.mobile,
        card: this.card,
        tpid: this.tpid || ''
      })
      Toast.loading({
        duration: 0,
        forbidClick: false
      })
      const url1 = `//soperationapi.cekid.com/soperation-api/traveling/addTravelingPerson.do?${qs}`
      const url2 = `//soperationapi.cekid.com/soperation-api/traveling/editTravelingPerson.do?${qs}`
      const url = this.tpid ? url2 : url1
      http
        .get(url)
        .then(res => {
          Toast.clear()
          if (res.errno === 505) {
            this.$$login()
          } else if (res.errno !== 0) {
            this.$$toast(res.errmsg)
          } else {
            this.$$toast(res.errmsg)
            let person = {}
            person.tpid = this.tpid ? this.tpid : res.data.tpid
            person.name = this.name
            person.mobile = this.mobile
            person.card = this.card
            person.index = this.index
            person.isChecked = this.isChecked
            this.$emit('editSuccess', person)
          }
        })
        .catch(() => {
          Toast.clear()
        })
    },
    doDeleteConfirm() {
      Msgbox({
        title: '提示',
        message: '删除这个游客信息？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'confirm',
        action: msgbox => {
          this.doDelete()
          this.dx = this.bx = 0
        },
        cancel: msgbox => {}
      })
    },
    async doDelete() {
      const { uid, skey } = await this.$$ensureLogin()
      if (!uid || !skey) return 1

      const qs = this.$$queryString.stringify({
        uid,
        skey,
        tpid: this.tpid
      })
      Toast.loading({
        duration: 0,
        forbidClick: false
      })
      const url = `//soperationapi.cekid.com/soperation-api/traveling/delTravelingPerson.do?${qs}`
      http
        .get(url)
        .then(res => {
          Toast.clear()
          if (res.errno === 505) {
            this.$$login()
          } else if (res.errno !== 0) {
            this.$$toast(res.errmsg)
          } else {
            this.$emit('removed', this.tpid)
          }
        })
        .catch(() => {
          Toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

$COLOR_ADULT: #5ba9fa;

.container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-bottom: rem(200px);
  overflow-x: hidden;
  overflow-y: auto;
  overflow-scrolling: touch;
  background-color: #fff;
}
.wrap {
  margin-left: rem(24px);
  margin-right: rem(24px);
}

.tips {
  font-size: rem(22px);
  color: #666666;
  line-height: rem(34px);
  font-weight: 400;
  margin-top: rem(32px);
}

.footer {
  z-index: 3;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  .btn {
    color: #fff;
    font-size: rem(32px);
    height: rem(80px);
    text-align: center;
    display: block;
    line-height: rem(80px);
    background-color: #ccc;
    i {
      margin-right: rem(10px);
    }
    &.activated {
      background-image: linear-gradient(90deg, #ff8800, #ff5900);
      border-radius: rem(40px);
      margin: 0 rem(24px) rem(68px) rem(24px);
    }
  }
}

input[type='number'] {
  ::-webkit-inner-spin-button {
    display: none;
  }
}

.input-item-right {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.btn_clear {
  width: rem(36px);
  height: rem(36px);
  display: none;
  &.display {
    display: inline;
  }
}

.btn_delete {
  display: block;
  margin: 0 auto;
  margin-top: rem(48px);
  width: 100%;
  height: rem(80px);
  line-height: rem(80px);
  border: 1px solid rgba(190, 190, 190, 1);
  border-radius: rem(40px);
  font-size: rem(32px);
  color: #666666;
}
</style>
